















































































import { SET_CURRENT_DUNNING_EMAIL_BLUEPRINT_ID } from '@/store/mutation-types';
import { SAVE_STATE } from '@/store/shared';
import { IEmail, IEmailBlueprint } from '@/store/types';
import Vue from 'vue';
import { mapGetters } from 'vuex';
import PrecisionRetriesBox from '@/components/Dunning/PrecisionRetriesBox.vue';

export default Vue.extend({
  name: 'CampaignSequence',
  components: {
    PrecisionRetriesBox,
  },
  data() {
    return {
      SAVE_STATE,
    };
  },
  computed: {
    ...mapGetters(['currentDunningCampaignBlueprintSaveState']),
    emails(): IEmailBlueprint[] {
      return this.$store.getters.currentCampaignEmailBlueprints.filter((email: IEmailBlueprint) => !email.delete);
    },
  },
  methods: {
    selectEmail(email: IEmailBlueprint): void {
      this.$store.commit(SET_CURRENT_DUNNING_EMAIL_BLUEPRINT_ID, email.guid);
    },
    addEmail(): void {
      this.$emit('addEmail');
      this.$nextTick(() => {
        const bottom = this.$refs.listBottom as HTMLElement;
        bottom.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      });
    },
  },
});
